<template>
  <div>
    <v-container v-if="!this.isReady">
      <v-layout>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-container>
    <template v-else>
      <v-container>
        <h2 class="font-weight-thin mt-4">Projet {{project.name}}</h2>
        <p>Créé le {{project.createdAt | formatDate('DD/MM/YYYY')}} à {{project.createdAt | formatDate('HH:mm')}}</p>
        <Keyword v-for="keyword in keywords" :key="keyword.id" :keyword="keyword" :refresh="fetchProject" :deleteKeyword="deleteKeyword"></Keyword>
        <v-card class="elevation-12 mt-5">
          <v-card-title class="headline font-weight-regular blue-grey white--text">Ajout d'un mot clé</v-card-title>
          <v-card-text>
            <v-form>
              <v-flex sm12 md5>
                <v-select
                  outline
                  v-model="form.lang"
                  :items="langs"
                  placeholder="Langue du mot clé (google)"
                  label="Langue du mot clé (google)"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-flex>
              <v-radio-group v-model="form.keywordKind" row>
                <v-radio label="Mot clé classique" value="classic"></v-radio>
                <v-radio label="Semrush" value="semrush"></v-radio>
              </v-radio-group>
              <v-flex sm12 md5>
                <v-text-field
                  label="Mot clé en français"
                  placeholder="Mot clé en français"
                  outline
                  v-model="form.frenchKeyword"
                ></v-text-field>
              </v-flex>
              <template v-if="form.keywordKind === 'classic'">
                <v-btn
                  color="info"
                  class="mt-0 mb-3 ml-0"
                  :loading="classicTranslateButtonLoading"
                  :disabled="classicTranslateButtonDisabled"
                  @click="classicTranslate"
                >Traduire</v-btn>
              </template>
              <template v-else>
                <v-btn
                  color="info"
                  class="mt-0 ml-0"
                  :loading="semrushButtonLoading"
                  :disabled="semrushButtonDisabled"
                  @click="semrush"
                >Semrush</v-btn>
                <div v-if="semrushResults" class="mt-3">
                  <div class="chips">
                    <v-chip
                      @click="selectSemrushResult(result.keyword)"
                      v-for="result in semrushResults"
                      :key="result.keyword"
                      outline
                      color="primary"
                      v-bind:class="{ selected: selectedSemrushResult === result.keyword }"
                    >{{result.keyword}} ({{result.volume}})
                    </v-chip>
                  </div>
                  <v-btn
                    color="info"
                    class="my-3 ml-0"
                    :loading="semrushTranslateButtonLoading"
                    :disabled="semrushTranslateButtonDisabled"
                    @click="semrushTranslate"
                  >Traduire</v-btn>
                </div>
              </template>
              <v-flex sm12 md5>
                <v-text-field
                  v-if="form.targetKeyword !== undefined"
                  label="Mot clé dans la langue cible"
                  placeholder="Mot clé dans la langue cible"
                  outline
                  v-model="form.targetKeyword"
                ></v-text-field>
              </v-flex>
            </v-form>

          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="submitDisabled" @click.prevent.native="addKeyword">Ajouter le mot clé</v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </template>
  </div>
</template>

<script>
  import get from 'lodash/get';
  import omit from 'lodash/omit';
  import Keyword from "./Keyword";
  import keywordMixin from "../keywordMixin";

  export default {
    components: { Keyword },
    mixins: [keywordMixin],
    props: ['projectId'],
    data() {
      return {
        form: {
          lang: undefined,
          keywordKind: 'classic',
          frenchKeyword: '',
          targetKeyword: undefined,
        },
        interval: undefined,
        project: undefined,
        logs: [],
        articleHeaders: [
          { text: 'Url', value: 'url' },
          { text: 'Nombre de mots (VO)', value: 'originalContentLength' },
          { text: 'Nombre de mots (VF)', value: 'originalContentLength' },
          { text: 'Statut', value: 'status' },
          { text: '', sortable: false },
        ],
        keywords: [],
        isPending: false,
        isReady: false,

      };
    },
    computed: {
      submitDisabled() {
        const keys = Object.keys(this.form);
        return keys.find( key => this.form[key] === undefined || this.form[key].toString().trim() === '') !== undefined;
      },
    },
    async destroyed() {
      clearInterval(this.interval);
    },
    methods: {
      originalLength(item) {
        return get(item, 'originalContent.contentLength', 0);
      },
      translatedLength(item) {
        return get(item, 'translatedContent.contentLength', 0);
      },
      async fetchProject() {
        const response = await this.$http.get(`/api/projects/${this.projectId}`);
        const { project, logs, keywords } = response.data;
        this.project = project;
        this.logs = logs;
        this.keywords = keywords;
      },
      async addKeyword() {
        if (this.submitDisabled) return;
        const data = {
          ...omit(this.form, 'keywordKind'),
          projectId: this.projectId,
        };
        const response = await this.$http.post('/api/keywords/add', data);
        const { project, logs, keywords } = response.data;
        this.project = project;
        this.logs = logs;
        this.keywords = keywords;

        this.form = {
          lang: undefined,
          keywordKind: 'classic',
          frenchKeyword: '',
          targetKeyword: undefined,
        };
      },
      async deleteKeyword(keywordId) {
        const response = await this.$http.get(`/api/projects/${this.projectId}/delete-keyword/${keywordId}`);
        const { project, logs, keywords } = response.data;
        this.project = project;
        this.logs = logs;
        this.keywords = keywords;
      }
    },
    watch: {
      projectId: {
        async handler() {
          await this.fetchProject();
          this.isReady = true;
        },
        immediate: true,
      }
    }
  }
</script>

<style scoped lang="scss">
  .logs{
    margin-top: 100px;
  }
  .action {
    display: flex;
    flex-direction: row;
    > button {
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>
